import { createActionCreators, createSocketListener } from '@mssgme/api-client';
import api from '@mssgme/api';

const actionCreators = createActionCreators(api);

actionCreators.init = () => async (dispatch) => {
    if (!api.isAuthenticated) {
        return;
    }

    const batch = (arr) => Promise.all(arr.map((item) => dispatch(item)));

    return batch([
        actionCreators.users.me(),
        actionCreators.workspaces.retrieve(),
        actionCreators.billing.details(),
        actionCreators.billing.products.prices(),
        actionCreators.websites.list(),
        actionCreators.collections.list(),
        // actionCreators.products.list(),
        // actionCreators.conversations.unread(),
    ]);
};

function createListener(eventName, transformPayload) {
    return createSocketListener(api, eventName, transformPayload);
}

const contactProduce = (contactId, payload) => ({ contactId, payload });
const feedbackProduce = (feedbackId, result) => ({ feedbackId, result });
const userUpdatedProduce = (event) => event;

// SocketObserver
actionCreators.listenConnect = createListener('connect');
actionCreators.listenDisconnect = createListener('disconnect');
actionCreators.listenReconnect = createListener('reconnect');
actionCreators.listenVerifyVersion = createListener('verifyVersion'); // TODO: remove

// AppObserver
actionCreators.listenUserUpdated = createListener('user_updated', userUpdatedProduce);

// InboxObserver
actionCreators.listenNewMessages = createListener('newMessages', contactProduce);
actionCreators.listenCreateConversation = createListener('createConversation', contactProduce);
actionCreators.listenUpdateConversation = createListener('updateConversation', contactProduce);

// BillingObserver
actionCreators.listenSubscriptionCreated = createListener('subscription_created');
actionCreators.listenSubscriptionUpdated = createListener('subscription_updated');
actionCreators.listenSubscriptionCancelled = createListener('subscription_cancelled');

actionCreators.listenPaymentSucceeded = createListener('subscription_payment_succeeded');
actionCreators.listenPaymentInitialSucceeded = createListener('initial_subscription_payment_succeeded');
actionCreators.listenPaymentFailed = createListener('subscription_payment_failed');
actionCreators.listenPaymentRetryFailed = createListener('retry_subscription_payment_failed');
actionCreators.listenHighRiskTransactionUpdated = createListener('high_risk_transaction_updated');

// FeedbackObserver
actionCreators.listenCreateFeedback = createListener('createFeedback', feedbackProduce);
actionCreators.listenUpdateFeedback = createListener('updateFeedback', feedbackProduce);

actionCreators.conversations.filterList = ({ query, ...rest } = {}) => {
    return (dispatch, getState) => {
        const state = getState();
        const { status, assign, searchValue, showNewFirst } = state.ui.conversationsFilter;

        query = {
            status,
            assign,
            searchValue,
            sort: showNewFirst ? 'new' : 'old',
            ...query,
        };

        return dispatch(actionCreators.conversations.list({ query, ...rest }));
    };
};

function createThunkAction(type, callback) {
    type = `@API/${type}`;
    const actionCreator = (payload) => async (dispatch) => {
        dispatch({ type, payload });
        await callback(payload);
    };
    actionCreator.type = type;
    actionCreator.toString = () => type;

    return actionCreator;
}

actionCreators.unsubscribe = createThunkAction('unsubscribe', ({ cancelUrl }) => {
    window.open(cancelUrl);
});

export default actionCreators;
